import { isAndroid } from 'react-device-detect';

import {
  IND_DOMAIN_SWITCH,
  IS_DEMO,
  IS_INDIAN_EXCHANGE,
  isRNWebview,
} from 'constants/constants';

import {
  FEATURE_FLAG_AUTO_MOBILE_OTP_VERIFICATION,
  FEATURE_FLAG_HYPERVERGE_CUSTOM_INPUT_SUPPORTED,
  FEATURE_FLAG_SCAN_TO_LOGIN_SUPPORTED,
  FEATURE_FLAG_TRADE_SUCCESS_CARD_SUPPORTED,
} from './rnApp';

const SIGNAL_TRADING_FEATURE_ENABLED =
  process.env.REACT_APP_FEATURE_FLAG_SIGNAL_TRADING === 'true' && IS_INDIAN_EXCHANGE;

const SIGNUP_CARDS_FLAG = IS_INDIAN_EXCHANGE ? 'india' : 'global';

const SHOW_DELTA_INDIA_LOGIN_LINK = !IS_INDIAN_EXCHANGE;

const TRADE_PREFERENCES_DETO_FOR_COMISSION = !IS_INDIAN_EXCHANGE;

const INVOICES_TAB = IS_INDIAN_EXCHANGE;

const ANNUAL_ACCOUNT_SUMMARY_TAB = IS_INDIAN_EXCHANGE;

const TDS_SUMMARY_TAB = IS_INDIAN_EXCHANGE;

const ENABLE_INR_TOGGLE_IN_ACCOUNT_ANALYTICS = IS_INDIAN_EXCHANGE;

const RECOVER_USER_ACCOUNT_FEATURE_ENABLED = IS_INDIAN_EXCHANGE;

const SHOW_DELTA_INDIA_ANALYTICS_REDIRECTION_LINK = !IS_INDIAN_EXCHANGE;

const SHOW_TRADE_SUCCESS_SHARE_CARDS =
  IS_INDIAN_EXCHANGE && FEATURE_FLAG_TRADE_SUCCESS_CARD_SUPPORTED;
const SHOW_DELTA_GLOBAL_LOGIN_LINK_ON_LOGIN_PAGE =
  IS_INDIAN_EXCHANGE && !isRNWebview() && IND_DOMAIN_SWITCH;

const SCALPING_ENABLED = IS_INDIAN_EXCHANGE;

const XMAS_OFFER_FOR_OPTIONS = IS_INDIAN_EXCHANGE;

const SHOW_DELTA_GLOBAL_BANK_WITHDRAWAL_PAGE = false;

const ENABLE_TRACK_DEPOSIT = IS_INDIAN_EXCHANGE;

const SCAN_TO_LOGIN_FEATURE_ENABLED =
  process.env.REACT_APP_FEATURE_FLAG_SCAN_TO_LOGIN === 'true';

const SHOW_SCANNER_FOR_LOGIN_VIA_QR =
  SCAN_TO_LOGIN_FEATURE_ENABLED && FEATURE_FLAG_SCAN_TO_LOGIN_SUPPORTED;

const SHOW_QR_SCREEN_FOR_LOGIN_VIA_QR = SCAN_TO_LOGIN_FEATURE_ENABLED && !isRNWebview();

const SHOW_DELTA_GLOBAL_LOGIN_LINK = !isRNWebview() && IND_DOMAIN_SWITCH && !IS_DEMO;

const DISABLE_2FA_FACE_AUTH_ENABLED = isRNWebview()
  ? FEATURE_FLAG_HYPERVERGE_CUSTOM_INPUT_SUPPORTED && IS_INDIAN_EXCHANGE
  : IS_INDIAN_EXCHANGE;

const ENABLE_MIXPANEL_SESSION_REPLAY =
  process.env.REACT_APP_FEATURE_FLAG_ENABLE_MIXPANEL_SESSION_REPLAY === 'true' &&
  IS_INDIAN_EXCHANGE;

const SHOW_DOWNLOAD_APP_BANNER = isAndroid && !isRNWebview() && !IS_DEMO;
const SHOW_FIAT_VALUE_IN_BELL_ALERTS = IS_INDIAN_EXCHANGE;

const SHOW_DOWNLOAD_APP_ICON = !isRNWebview() && !IS_DEMO;

const SHOW_ORDER_ACCOUNT_STATUS = IS_INDIAN_EXCHANGE;
const SHOW_MOBILE_UPNL_STATUS = IS_INDIAN_EXCHANGE;

const GRACE_KYC_EXPIRY_AVAILABLE = IS_INDIAN_EXCHANGE;

const ENABLE_AUTO_MOBILE_OTP_VERIFICATION =
  isRNWebview() && IS_INDIAN_EXCHANGE && FEATURE_FLAG_AUTO_MOBILE_OTP_VERIFICATION;

const BREAK_EVEN_PRICE_VIEW_ENABLED = IS_INDIAN_EXCHANGE;

const ACCOUNT_EQUITY_CHART_DATE_TO_UTC_TIMEZONE = false;

const RENEW_KYC_SELFIE_VERIFICATION_ENABLED = IS_INDIAN_EXCHANGE;
const API_COPILOT_FEATURE_ENABLED = IS_INDIAN_EXCHANGE;

const SOURCE_INCOME_ENABLED = IS_INDIAN_EXCHANGE;
const WHITE_THEME_SHARE_CARD_ENABLED = IS_INDIAN_EXCHANGE;
const DC_TO_FV_ENABLED = IS_INDIAN_EXCHANGE;
const FORGOT_EMAIL_ID_ENABLED = IS_INDIAN_EXCHANGE;

const SHOULD_FETCH_GLOBAL_DEPOSIT_ASSETS = !IS_INDIAN_EXCHANGE;

export {
  ACCOUNT_EQUITY_CHART_DATE_TO_UTC_TIMEZONE,
  ANNUAL_ACCOUNT_SUMMARY_TAB,
  API_COPILOT_FEATURE_ENABLED,
  BREAK_EVEN_PRICE_VIEW_ENABLED,
  DISABLE_2FA_FACE_AUTH_ENABLED,
  ENABLE_AUTO_MOBILE_OTP_VERIFICATION,
  ENABLE_INR_TOGGLE_IN_ACCOUNT_ANALYTICS,
  ENABLE_MIXPANEL_SESSION_REPLAY,
  ENABLE_TRACK_DEPOSIT,
  GRACE_KYC_EXPIRY_AVAILABLE,
  INVOICES_TAB,
  XMAS_OFFER_FOR_OPTIONS,
  RECOVER_USER_ACCOUNT_FEATURE_ENABLED,
  RENEW_KYC_SELFIE_VERIFICATION_ENABLED,
  SCALPING_ENABLED,
  SHOW_DELTA_GLOBAL_BANK_WITHDRAWAL_PAGE,
  SHOW_DELTA_GLOBAL_LOGIN_LINK,
  SHOW_DELTA_GLOBAL_LOGIN_LINK_ON_LOGIN_PAGE,
  SHOW_DELTA_INDIA_ANALYTICS_REDIRECTION_LINK,
  SHOW_DELTA_INDIA_LOGIN_LINK,
  SHOW_DOWNLOAD_APP_BANNER,
  SHOW_DOWNLOAD_APP_ICON,
  SHOW_ORDER_ACCOUNT_STATUS,
  SHOW_MOBILE_UPNL_STATUS,
  SHOW_FIAT_VALUE_IN_BELL_ALERTS,
  SHOW_QR_SCREEN_FOR_LOGIN_VIA_QR,
  SHOW_SCANNER_FOR_LOGIN_VIA_QR,
  SHOW_TRADE_SUCCESS_SHARE_CARDS,
  SIGNAL_TRADING_FEATURE_ENABLED,
  SIGNUP_CARDS_FLAG,
  TDS_SUMMARY_TAB,
  TRADE_PREFERENCES_DETO_FOR_COMISSION,
  SOURCE_INCOME_ENABLED,
  WHITE_THEME_SHARE_CARD_ENABLED,
  DC_TO_FV_ENABLED,
  FORGOT_EMAIL_ID_ENABLED,
  SHOULD_FETCH_GLOBAL_DEPOSIT_ASSETS,
};
